import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IPageSectionProps } from '../components/page-section/page-section';

export class PageSectionModel extends ContentItem {
  get containItems(): IKontentItem[] {
    return get(this._config, 'elements.contain_items.value', []);
  }
  get sectionId(): string {
    return get(this._config, 'elements.unique_id.value', '');
  }
  get additionamMarginInColumn(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_column.value[0].codename',
      ''
    );
  }
  get additionamMarginInRow(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_row.value[0].codename',
      ''
    );
  }
  get aligmentInColumn(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_column.value[0].codename',
      'default'
    );
  }
  get aligmentInRow(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_row.value[0].codename',
      'default'
    );
  }
  get backgroundColor(): string {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      ''
    );
  }
  get backgroundAsset(): string {
    return get(this._config, 'elements.background_asset.value[0].url', '');
  }
  get predefinedContainer(): boolean {
    return JSON.parse(
      get(
        this._config,
        'elements.page_properties__predefined_container.value[0].codename',
        false
      )
    );
  }
  get withBorder(): boolean {
    return JSON.parse(
      get(
        this._config,
        'elements.page_properties__with_border.value[0].codename',
        false
      )
    );
  }

  get dotsInBackground(): boolean {
    return (
      get(this._config, 'elements.dots_in_background.value[0].codename', '') ===
      'true'
    );
  }

  get removeMargin(): string {
    return get(this._config, 'elements.remove_margin.value[0].codename', null);
  }

  public static create(data: IPageSection): IPageSectionProps {
    const {
      containItems,
      sectionId,
      additionamMarginInColumn,
      additionamMarginInRow,
      aligmentInColumn,
      aligmentInRow,
      backgroundColor,
      backgroundAsset,
      predefinedContainer,
      withBorder,
      dotsInBackground,
      removeMargin
    } = new PageSectionModel(data);
    return {
      containItems,
      sectionId,
      additionamMarginInColumn,
      additionamMarginInRow,
      aligmentInColumn,
      aligmentInRow,
      backgroundColor,
      backgroundAsset,
      predefinedContainer,
      withBorder,
      dotsInBackground,
      removeMargin
    };
  }
}
